import { Fragment, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { crearUnidad } from '../../../actions/configuracion';
import { setAlert } from '../../../actions/alert';

const NuevaUnidadModal = ({ show, onHide, onSuccess }) => {
    const dispatch = useDispatch();

    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');

    useEffect(() => {
        if (!show) return;

        setNombre('');
        setDescripcion('');
    }, [show]);

    const onGuardar = async (e) => {
        e.preventDefault();

        const n = (nombre || '').trim();
        if (!n) {
            dispatch(setAlert('El nombre es requerido', 'danger'));
            return;
        }

        const ok = await dispatch(crearUnidad({
            nombre: n,
            descripcion: (descripcion || '').trim()
        }));

        if (!ok) return;

        if (typeof onSuccess === 'function') {
            await onSuccess();
        } else if (typeof onHide === 'function') {
            onHide();
        }
    };

    return (
        <Fragment>
            <Modal show={show} onHide={onHide} centered size="lg">
                <form onSubmit={onGuardar}>
                    <Modal.Header closeButton>
                        <Modal.Title>Nueva unidad</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    autoFocus
                                />
                            </div>

                            <div className="col-12">
                                <textarea
                                    className="form-control"
                                    placeholder="Descripción"
                                    rows="4"
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                />
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={onHide}>
                            Cerrar
                        </button>

                        <button type="submit" className="btn btn-success">
                            <i className="fas fa-check" /> Guardar
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </Fragment>
    );
};

export default NuevaUnidadModal;
